"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dataGridContext = _interopRequireDefault(require("../../data-grid-context"));

var _Pagination = _interopRequireDefault(require("@material-ui/lab/Pagination"));

var FooterPagination = function FooterPagination(_ref) {
  var totalCount = _ref.totalCount,
      pageSize = _ref.pageSize;

  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      paginationApi = _useContext.paginationApi;

  var onPaginationGoToPage = (0, _react.useCallback)(function (number) {
    paginationApi.goToPage(number, pageSize);
  }, [paginationApi]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 mt-4 d-flex justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement(_Pagination["default"], {
    size: "large",
    count: Math.ceil(totalCount / pageSize),
    onChange: function onChange(_, number) {
      return onPaginationGoToPage(number);
    }
  }));
};

FooterPagination.propTypes = {
  totalCount: _propTypes["default"].number.isRequired,
  pageSize: _propTypes["default"].number
};
FooterPagination.defaultProps = {
  pageSize: 24
};
var _default = FooterPagination;
exports["default"] = _default;